module.exports = __webpack_public_path__ + "static/img/Ellipse 121.4844658.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ellipse 121.png
// module id = 3e+e
// module chunks = 1